module.exports = __webpack_public_path__ + "media/images/featured-products/scbs-1b8f9d7f4fcb72c8829d208562b9b386.svg";